const COMMON_TLDS = [
  "com",
  "de",
  "net",
  "org",
  "info",
  "io",
  "eu",
  "at",
  "ch",
  "co",
  "uk",
  "biz",
  "edu",
  "gov",
  "me",
  "app",
  "dev",
  "cloud",
  "online",
  "tech",
];

const COMMON_DOMAINS = [
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.de",
  "hotmail.com",
  "outlook.com",
  "outlook.de",
  "web.de",
  "gmx.de",
  "gmx.net",
  "gmx.at",
  "t-online.de",
  "freenet.de",
  "posteo.de",
  "mailbox.org",
  "icloud.com",
  "me.com",
  "live.de",
  "live.com",
  "aol.com",
  "protonmail.com",
  "proton.me",
];

function findEmailIssues(email) {
  const value = email.trim();
  if (!value) return null;

  if ((value.match(/@/g) || []).length > 1) {
    return "Deine E-Mail-Adresse enthält mehrere @-Zeichen.";
  }

  if (!value.includes("@")) {
    return "Deine E-Mail-Adresse muss ein @-Zeichen enthalten.";
  }

  const [local, domain] = value.split("@");

  if (!local) {
    return "Vor dem @-Zeichen fehlt der Benutzername.";
  }

  if (!domain || !domain.includes(".")) {
    return "Die Domain scheint unvollständig zu sein (z.\u00a0B. beispiel.de).";
  }

  const tld = domain.split(".").pop().toLowerCase();

  if (tld.length < 2) {
    return "Die Domainendung scheint zu kurz zu sein.";
  }

  const typoMap = {
    dee: "de",
    ded: "de",
    der: "de",
    comn: "com",
    comm: "com",
    cmo: "com",
    con: "com",
    vom: "com",
    nett: "net",
    ner: "net",
    ned: "net",
    orgg: "org",
    ogr: "org",
    att: "at",
    ad: "at",
    cch: "ch",
    ioo: "io",
    euu: "eu",
  };

  if (typoMap[tld]) {
    return `Meintest du „.${typoMap[tld]}" statt „.${tld}"?`;
  }

  if (!COMMON_TLDS.includes(tld)) {
    const startsWith = COMMON_TLDS.find(
      (t) => tld.startsWith(t) && tld.length > t.length && tld.length <= t.length + 3,
    );
    if (startsWith) {
      return `Meintest du „.${startsWith}" statt „.${tld}"?`;
    }

    const levenMatch = COMMON_TLDS.find(
      (t) => levenshtein(tld, t) === 1,
    );
    if (levenMatch) {
      return `Meintest du „.${levenMatch}" statt „.${tld}"?`;
    }
  }

  const domainLower = domain.toLowerCase();
  const domainMatch = COMMON_DOMAINS.find(
    (d) => d !== domainLower && levenshtein(domainLower, d) === 1,
  );
  if (domainMatch) {
    return `Meintest du „${domainMatch}" statt „${domain}"?`;
  }

  return null;
}

function levenshtein(a, b) {
  const m = a.length,
    n = b.length;
  if (Math.abs(m - n) > 1) return 2;
  const dp = Array.from({ length: m + 1 }, (_, i) => i);
  for (let j = 1; j <= n; j++) {
    let prev = dp[0];
    dp[0] = j;
    for (let i = 1; i <= m; i++) {
      const tmp = dp[i];
      dp[i] =
        a[i - 1] === b[j - 1] ? prev : 1 + Math.min(prev, dp[i], dp[i - 1]);
      prev = tmp;
    }
  }
  return dp[m];
}

function attachValidator(field) {
  if (!field || field.dataset.emailValidatorAttached) return;
  field.dataset.emailValidatorAttached = "true";

  const hint = document.createElement("div");
  hint.className = "alert alert-info small py-2 px-2h mt-1";
  hint.style.display = "none";
  field.parentNode.appendChild(hint);

  function validate() {
    const issue = findEmailIssues(field.value);
    if (issue) {
      hint.textContent = issue;
      hint.style.display = "block";
    } else {
      hint.style.display = "none";
    }
  }

  field.addEventListener("blur", validate);
  field.addEventListener("input", () => {
    if (hint.style.display === "block") validate();
  });
}

function init() {
  document
    .querySelectorAll(
      'input[type="email"], input[name*="[email]"], input[id$="_email"]',
    )
    .forEach(attachValidator);
}

document.addEventListener("turbo:load", init);
